export default __webpack_public_path__ + "static/media/map-pin-line.3d5e9d5d.svg";